import { request } from '@/utils'
import { BusinessCompanyInfoType, CompanyInfoInGroupItemType } from '@/types'

// 获取采购商详情 

export interface ICompanyInfoParams {
    memberId?: string
    groupId?: string
    companyId?:  string
    companyName?: string
}

export async function getInquiryContactInfo(opportunityId: string) {
  return request.get(
    `/bcpcrm/rest/api/opportunity/queryContactInfo`,
    { params: { opportunityId } },
  );
}
export const getMemberCompanyInfo = async (params: ICompanyInfoParams): Promise<BusinessCompanyInfoType> => {
    return request.get(
      `/api/ycx/caigou/portal/company/companyInfo`,
      {
        params: params,
      }
    )
  }

// 获取门户memberId
export const getSiteDomainInfo = async (): Promise<any> => {
  return request.get(
    `/api/ycx/caigou/portal/siteDomain/siteDomainInfo`,
    {
      headers: {
        "X-Domain": window.location.origin,
      },
    }
  )
}

// 获取集团下的企业信息 
export const getCompanyInfoInGroup = async (params: {groupId?: string, memberId?: string}): Promise<CompanyInfoInGroupItemType[]> => {
  return request.get(
    `/api/ycx/caigou/portal/company/queryCompanyInfoInGroup`,
    {
      params: params
    }
  )
}

// 获取竞价详情
export const getBiddingDetail = async(params:string|number) => {
  return request.get(`/bcpcrm/rest/api/auction/queryDetail`,{
    params:{
      opportunityId:params
    }
  })
}

// 获取询价详情
export const getInquiryDetail = async(params:string|number) => {
  return request.get(`/bcpcrm/rest/api/quotation/inquiry/queryDetail`,{
    params:{
      opportunityId:params
    }
  })
}

// 获取招标详情
export const getTenderDetail = async(params:string|number) => {
  return request.get(`/bcpcrm/rest/api/bidding/queryDetail`,{
    params:{
      opportunityId:params
    }
  })
}

// 获取招募单详情
export const getRecruitmentDetail = async(params:string|number) => {
  return request.get(`/bcpcrm/rest/api/recruit/queryDetail`,{
    params:{
      opportunityId:params
    }
  })
}

// 获取推荐商机列表
export const getRecommendBusinessList = async(data:any) => {
  return request.post(`/bcpcrm/rest/api/opportunity/v2/recommendV2`,{
    ...data,
  })
}

// 获取商机推荐新
export const getRecommendBusinessListNew = async(data:any) => {
  return request.post(`/bcpcrm/rest/api/opportunity/v2/recommendPage`,{
    ...data,
  })
}

// 获取商机推荐v3
export const getRecommendBusinessListV3 = async(data:any) => {
  return request.post(`/bcpcrm/rest/api/opportunity/v2/recommendPageV3`,{
    ...data,
  })
}

// 获取相似商机列表（详情页传参只传parentOpportunityId）
export const getSimilarBusinessList = async(data:any) => {
  return request.get(`/bcpcrm/rest/api/opportunity/v2/similarOpportunityV2`,{
    params:data,
  })
}

// 获取跳转详情url
export const getWebsite = async(data:{ opportunityId: string; quotationId: any }): Promise<any> => {
  return request.get(`/bcpcrm/rest/api/quotation/quotation/website`,{
    params:data,
  })
}

//获取招标column
export const getBiddingColumn = async(params:string|number) => {
  return request.get(`/bcpcrm/rest/api/bidding/biddingDetailTemplate`,{
    params:{
      opportunityId:params
    }
  })
}

// 签署保密协议
export const signAgreement = async(data: any): Promise<any> => request.post('/bcpcrm/rest/api/quotation/inquiry/signPrivacy', data);

// 主搜索接口 - 找商机搜索页面
export const getMainSearchV2 = async(data:any) => {
  return request.post(`/bcpcrm/rest/api/opportunity/v2/mainSearchV2`, data).then((res:any)=>{
    const {data, other} = res
    return {
      ...data,
      ...other
    }
  })
}

// AI搜索接口 - 找商机搜索页面
/**
 * 
 * @param data 
 * paymentWayList: string[] 支付方式列表
 * businessOpportunityType: string  商机类型
 * companyName: string 公司名称
 * categoryNameList: string[] 采购品类名称列表
 * receiveCityList: string[] 接收城市列表
 * receiveProvinceList: string[] 接收省列表
 * industryCodes: string[] 行业列表
 * source: string 来源
 * deadlineFrom: string 截止时间从
 * deadlineTo: string 截止时间到
 * onlyOnlineQuote: boolean 是否只在线报价
 * onlyBiddingInProgress: boolean 是否只招标进行中
 * prefCategoryIds: string[] 用户偏好：采购品类
 * prefRegionCodes: string[] 用户偏好：地区
 * prefIndustryCodes: string[] 用户偏好：行业
 * keyWordList: string[] 关键词列表
 * typeTagList: string[] 类型列表
 * materialUnionList: string[] 物料模糊查询关键词列表
 * @returns 
 */
export const getMainSearchV2AI = async(data:any) => {
  return request.post(`/bcpcrm/rest/api/opportunity/v2/aiCustomizedSearchV2`, data).then((res:any)=>{
    const {data, other} = res
    return {
      ...data,
      ...other
    }
  })
}


// 提交询价报名
export const submitBuyOffer = async(data:any) => {
  return request.post(`/bcpcrm/rest/api/buyoffer/apply`,{
    ...data,
  })
}



//获取招标公告详情
export const getTenderAnnouncementDetail = async(id:string|number,source:string) => {
  return request.get(`/bcpcrm/rest/api/bidding/${id}/digest`,{
    params:{
      opportunityId:id,
      source
    }
  })
}

//商机点赞
export const likeBusiness = async(data:any) => {
  return request.post(`/bcpcrm/rest/api/like/like`,data)
}

// 商机取消点赞
export const cancelLikeBusiness = async(opportunityId:any) => {
  return request.post(`/bcpcrm/rest/api/like/cancelLike`,{
    opportunityId,
  })
}


// 招募提交
export const submitRecruit = async(data:any) => {
  return request.post(`/bcpcrm/rest/api/recruit/apply`,{
    ...data,
  })
}

// 订阅规则相关接口
export interface ISubscribeRuleParams {
  type: "BUSINESS_OPPORTUNITY" | "CORPORATION" | "CORPORATION_SUBSCRIBE" | "CORPORATION企业订阅规则" | "BUSINESS_OPPORTUNITY高级订阅规则" | number;
  buyer_member_id: string;
}

// 创建订阅规则
export const createSubscribeRule = async (params: ISubscribeRuleParams): Promise<any> => {
  return request.post('/crm/cdi/api/v1/subscribeRules/createAccountSubscribeRule', params);
}

// 调试版本的订阅接口 - 绕过响应拦截器
export const createSubscribeRuleDebug = async (params: any): Promise<any> => {
  try {
    const response = await request.post('/crm/cdi/api/v1/subscribeRules/createAccountSubscribeRule', {...params});
    console.log('原始响应:', response);
    return response;
  } catch (error: any) {
    console.log('原始错误响应:', error.response?.data);
    throw error;
  }
}
// 招标单提交
export const submitBidding = async(data:any) => {
  return request.post(`/bcpcrm/rest/api/bidding/apply`,{
    ...data,
  })
}

// 竞价单提交
export const submitAuction = async(data:any) => {
  return request.post(`/bcpcrm/rest/api/auction/apply`,{
    ...data,
  })
}

// 收藏商机(标讯)
export const favoriteBusiness = async(data:any) => {
  return request.post(`/crm/bcpcrm/rest/api/favorite`,{
    ...data,
  })
}
export const cancelFavoriteBusinessN = async(data:any) => {
  return request.delete(`/crm/bcpcrm/rest/api/favorite`,{
    data: data, 
  })
}
//  收藏商机（商机）
export const favoriteBusinessB = async(data:any) => {
  return request.post(`/crm/cdi/api/v1/saas-favorite/cluesFavorite`,{
    ...data,
  })
}


// 取消收藏商机
export const cancelFavoriteBusiness = async(data:any) => {
  return request.delete(`/crm/cdi/api/v1/saas-favorite`,{
    data,
  })
}

// 企业订阅
export const subscribeCorporation = async(data:any) => {
  return request.post(`/crm/cdi/api/v1/subscribeRules/createAccountSubscribeRule`,{
    ...data,
  })
}

// 取消企业订阅
export const cancelSubscribeCorporation = async(data:any) => {
  return request.post(`/crm/cdi/api/v1/subscribeRules/deleteSubscribeRule`,{
    ...data,
  })
}



//签署保密协议
export const signPrivacyAgreement = async(data:any) => {
  return request.post(`/bcpcrm/rest/api/quotation/inquiry/signPrivacy`,{
    ...data,
  })
}

//详情查询是否收藏
export const getDetailIsFavorite = async(data:any) => {
  return request.get(`/bcpcrm/rest/api/favorite/judge`,{
    params:data,
  })
}

// 取消收藏
export const cancelFavorite = async(data:any) => {
  return request.delete(`/crm/cdi/api/v1/saas-favorite`,{
    ...data,
  })
}

//详情查询点赞接口
export const getDetailIsThumbs = async(data:any) => {
  return request.post(`/crm/bcpcrm/rest/api/like/isSingleLike`,{
    ...data,
  })
}

//商机反馈
export const postFeedBack = async(data:any) => {
  return request.post(`/crm/bcpcrm/rest/api/supplier/feedback`,{
    ...data,
  })
}

// 扣除报价券
export const postDeductQuotation = async(data:any) => {
  return request.post(`/bcpcrm/rest/api/quotation/payQuotation`,{
    ...data,
  })
}

// 扣除白名单权益
export const payMySupplierWhite = async(data:any) => {
  return request.post(`/bcpcrm/rest/api/quotation/payMySupplierWhite`,{
    ...data,
  })
}

// 三方商机报名接口 
export const postThirdApply = async(data:any) => {
  return request.post(`/bcpcrm/rest/api/buyoffer/third/apply`,{
    ...data,
  })
}

// 获取询价表单模板
export const getInquiryFormTemplate = async(data:any) => {
  return request.get(`/bcpcrm/rest/api/quotation/inquiry/getDetailTemplate`,{
    params:{
      opportunityId:data,
    },
  })
}

// 获取招标单保密协议模板id
export const getTenderPrivacyAgreementId = async(purchaseId:any) => {
  return request.get(`/event/app/bid_detail_brand_new/get_bidding_detail_template.json`,{
    params:{purchaseId},
  })
}

// 获取招标单保密协议
export const getTenderPrivacyAgreement = async(data:any) => {
  return request.get(`/event/app/bid_detail_brand_new/get_bidding_detail.json`,{
    params:data,
  })
}

// 获取订阅的企业
export const getSubscribeCorporation = async() => {
  return request.post(`/crm/cdi/api/v1/subscribeRules/querySubscribeRuleList`)
}

// 查询当前账号今日是否已关闭商机详情引导弹框
export const getOpportunityDetailGuideCloseStatus = async (): Promise<boolean> => {
  return request.get(
    `/crm/cdi/api/v1/popup-close/status?popupType=OPPORTUNITY_DETAIL_GUIDE`,
  );
}

// 关闭当前账号今日的商机详情引导弹框
export const closeOpportunityDetailGuide = async () => {
  return request.post(
    `/crm/cdi/api/v1/popup-close/close?popupType=OPPORTUNITY_DETAIL_GUIDE`,
  );
}

// 公告解锁接口
export const unlockTenderAnnouncement = async(data:any) => {
  return request.get(`/bcpcrm/rest/api/member-quota/type-list/detail`,{
    params:data,
  })
}

// 公告解锁消息
export const getUnlockTenderAnnouncement = async(data:any) => {
  return request.get(`/bcpcrm/rest/api/bidding/workbench/${data?.opportunityId}`,{
    params:data,
  })
}

// 公告initInfo
export const getBiddingInitInfo = async(data:any) => {
  return request.get(`/bcpcrm/rest/api/bidding/${data?.opportunityId}/digest`,{
    params:data,
  })
}

// 招标下载文件的回调统计
export const submitTenderDownload = async(params:any) => {
  return request.post(`/bcpcrm/rest/api/bidding/documentsDownload`,{
    ...params,
  })
}

// 查询商机类型
export const getBusinessType = async(params:any) => {
  return request.post(`/bcpcrm/rest/api/quotation/inquiry/getPurchaseType`,{
    ...params,
  })
}

// 澄清答疑 - 查询
export const queryMessageList = async(params:any) => {
  return request.get('/bcpcrm/rest/api/quotation/inquiry/getPurchaseMessage',{
    params,
  })
}

// 澄清答疑 - 发送消息
export const sendMessage = async(data:any) => {
  // 将数据对象转换为文本格式，用 && 连接
  const textData = Object.entries(data)
    .map(([key, value]) => `${key}=${value}`)
    .join('&&');
  
  return request.post('/event/app/sourcing_buyoffer_detail/send_classify_message.json', textData)
}

// 查询名片
export const getBusinessCard = async(data:any) => {
  return request.post(`/bcpcrm/rest/api/supplier/selfRecommendation/supplierBusinessCardDetail`,data)
}
// 修改名片
export const updateBusinessCard = async(data:any) => {
  return request.post(`/bcpcrm/rest/api/supplier/selfRecommendation/updateSupplierCard`,data)
}
// 发送名片
export  const sendBusinessCard = async(data:any)=>{
  return request.post('/bcpcrm/rest/api/supplier/selfRecommendation/sendSupplierCard',data)
}
export const handleTalk = async(data:any)=>{
  return request.post('/bcpcrm/rest/api/quotation/inquiry/markPurchaseMessageRead',data)
}

export const trackingPoint = async (params: any): Promise<any> => {
  return request.get(
   `/crm/cdi/api/v1/business-opportunities/rv/${params}`
  )
}

// 下载状态检查
export const checkDownload = async (params: any): Promise<any> => {
  return request.get(
    `/bcpcrm/rest/api/bidding/checkDownload`,
    { params }
  )
}

export const checkDownloadVerify = async (params: any): Promise<any> => {
  return request.post(
    `/bcpcrm/rest/api/bidding/verifyDownloadCode`,
    { ...params }
  )
}

// 获取今日新增商机数
export const getTodayOpportunityCount = async () => {
  return request.get(`/bcpcrm/rest/api/opportunity/v2/today-opportunity-count`)
}


export const getRecommendEnterprise = async(data:any)=>{
  return request.post('/api/biz/portal/recommend',data)
}

// 企业搜索分页
export const searchEnterprisePage = async (data: any) => {
  return request.post('/api/biz/portal/page', data);
};

// 项目推荐分页
export const getRecommendProject = async (data: {
  pageIndex?: number;
  pageSize?: number;
}) => {
  return request.post("/api/biz/portal/project/recommend", data);
};

// 项目搜索分页
export const searchProjectPage = async (data: any) => {
  return request.post("/api/biz/portal/project/page", data);
};

// 项目详情
export const getProjectDetail = async (projectKey: string) => {
  return request.get(`/api/biz/portal/project/detail/${projectKey}`);
};

// 查询当前登录会员解锁权益（与采购企业共用同一额度账户）
export const getProjectUnlockEntitlement = async () => {
  return request.get(`/api/biz/portal/project/unlock/entitlement`);
};

// 为该项目解锁创建图片验证码（无请求体）
export const getProjectUnlockCaptcha = async (projectKey: string) => {
  return request.post(`/api/biz/portal/project/${projectKey}/unlock/captcha`);
};

// 项目维度解锁（一次解锁该项目全部受限联系人）
export const unlockProjectContact = async (data: {
  projectKey: string;
  idempotencyKey: string;
  captchaId?: string;
  captchaCode?: string;
}) => {
  const { projectKey, idempotencyKey, captchaId, captchaCode } = data;
  return request.post(`/api/biz/portal/project/${projectKey}/unlock`, {
    idempotencyKey,
    ...(captchaId && captchaCode ? { captchaId, captchaCode } : {}),
  });
};

// 获取门户详情
export const getPortalDetail = async (enterpriseKey: string) => {
  return request.get(`/api/biz/portal/detail/${enterpriseKey}`);
};

// 查询当前登录供应商解锁权益
export const getUnlockEntitlement = async () => {
  return request.get(`/api/biz/portal/enterprise/unlock/entitlement`);
};

// 解锁采购企业联系人
export const unlockEnterpriseContact = async (data: {
  enterpriseKey: string;
  contactId: number;
  idempotencyKey: string;
  captchaId?: string;
  captchaCode?: string;
}) => {
  return request.post('/api/biz/portal/enterprise/unlock/contact', data);
};

// 获取解锁验证码
export const getUnlockCaptcha = async (data: {
  enterpriseKey: string;
  contactId: number;
}) => {
  return request.post('/api/biz/portal/enterprise/unlock/captcha', data);
};

// 发送联系方式到手机
// 兼容两种入参：有 unlockRecordId 时按解锁记录发送，否则按 enterpriseKey + contactId 发送
export const sendContactToMobile = async (data: {
  unlockRecordId?: number;
  enterpriseKey?: string;
  contactId?: number;
  idempotencyKey: string;
  receiverMobile: string;
}) => {
  const { unlockRecordId, enterpriseKey, contactId, idempotencyKey, receiverMobile } = data;
  const payload = unlockRecordId
    ? { unlockRecordId, idempotencyKey, receiverMobile }
    : { enterpriseKey, contactId, idempotencyKey, receiverMobile };
  return request.post('/api/biz/portal/enterprise/unlock/contact/send-to-mobile', payload);
};